//* 组件库
import type { UiTypes } from "various-ui";

export const useOptions = () => {
    return {
        //* 物种信息
        species: [
            { label: "Human", value: "9606" },
            { label: "Mouse", value: "10090" },
            { label: "Rat", value: "10116" },
        ],

        //* 序列信息
        sequence: [
            { label: "DNA", value: "dna" },
            { label: "RNA", value: "rna" },
            { label: "Protein", value: "protein" },
        ],

        //* 基因组配置
        assembly: <{ [name: string]: UiTypes.candidate[] }>{
            9606: [
                { label: "GRCh38/hg38", value: "hg38" },
                { label: "GRCh37/hg19", value: "hg19" },
            ],
            10090: [
                { label: "GRCm39/mm39", value: "mm39" },
                { label: "GRCm38/mm10", value: "mm10" },
            ],
            10116: [
                { label: "mRatBN7.2/rn7", value: "rn7" },
                { label: "RGSC 6.0/rn6", value: "rn6" },
            ],
        },
    };
};
